import { render, staticRenderFns } from "./Breadcrumbs.vue?vue&type=template&id=df01e1dc&scoped=true&"
import script from "./Breadcrumbs.vue?vue&type=script&lang=js&"
export * from "./Breadcrumbs.vue?vue&type=script&lang=js&"
import style0 from "./Breadcrumbs.vue?vue&type=style&index=0&id=df01e1dc&prod&scoped=true&lang=css&"
import style1 from "./Breadcrumbs.vue?vue&type=style&index=1&id=df01e1dc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df01e1dc",
  null
  
)

export default component.exports